import type { Translate } from '../i18n';

/**
 * The country list, and its labels.
 *
 * ⚠️⚠️ **MOVED OUT OF `client-dialog.tsx` BY C42, WHICH NEEDED THE SECOND CALLER.** A workspace
 * gains a country (`decisions.md` P3-4) and it is the key the public-holiday import runs on, so the
 * settings screen offers the same list a client's address does. Two copies would have drifted the
 * first time somebody added a country to one of them.
 *
 * ⚠️ **ISO 3166-1 alpha-2, and the labels are `t()` per branch with a LITERAL key.** A computed
 * `t(\`country.${code}\`)` is invisible to the catalogue gate and to anybody grepping for a string,
 * which is the rule the i18n module states and this file would be the easiest place to break.
 */
export const COUNTRIES = ['HU', 'DE', 'AT', 'SK', 'RO', 'GB', 'US'] as const;
export type CountryCode = (typeof COUNTRIES)[number];

export function countryName(t: Translate, code: string): string {
  if (code === 'HU') return t('country.HU');
  if (code === 'DE') return t('country.DE');
  if (code === 'AT') return t('country.AT');
  if (code === 'SK') return t('country.SK');
  if (code === 'RO') return t('country.RO');
  if (code === 'GB') return t('country.GB');
  if (code === 'US') return t('country.US');
  /* ⚠️ The CODE, not an em-dash. A workspace whose country we have no label for still has one, and
     showing `PL` is a fact where *"–"* would read as *"none"*. */
  return code;
}
